import IForm from '../../IForm';
import { ExtraProps } from '../../../_lib/components/PersonalMessages/partials/PersonalMessageUtils';
import { SonForm } from '../../../_lib/Form2';

export enum PersonalMessageState {
  READ = 'read',
  UNREAD = 'unread',
}

export interface PersonalMessageLink {
  name: string;
  url?: string;
}

export interface PersonalMessageContent {
  links: { [linkName: string]: PersonalMessageLink };
  creationDate: string;
  userContent?: string;
  subcategory?: string;
  extraProps: ExtraProps;
}
export interface PersonalMessage {
  content: PersonalMessageContent;
  messageState: PersonalMessageState;
  id: string;
}

export function isPersonalMessageList(value: any): value is PersonalMessageList {
  return value && 'unreadCount' in value && 'readForm' in value && 'messageCategory' in value && 'items' in value;
}
export function isPersonalMessage(value: any): value is PersonalMessage {
  return value && 'id' in value && 'messageState' in value && 'content' in value;
}

export interface PersonalMessageList {
  messageCount: number;
  unreadCount: number;
  readForm: IForm;
  deleteForm: SonForm<any>;
  messageCategory: string;
  items: PersonalMessage[];
}
